import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: true,
    data: {},
    error: null,
}
export const domainInfoSlice = createSlice({
    name: 'domainInfo',
    initialState,
    reducers: {
        setDomainInfoLoading: (state, action) => {
            state.loading = action.payload;
        },
        setDomainInfo: (state, action) => {
            state.loading = false;
            state.data = action.payload;

        },
        resetDomainInfo: () => initialState,

    },
});

export const { setDomainInfoLoading, setDomainInfo, resetDomainInfo } = domainInfoSlice.actions;

export const selectDomainInfo = (state) => state.domainInfo;
export default domainInfoSlice.reducer;